import React from "react";
import TwoFactorAuthVerfication from "./TwoFactorAuthVerfication";
import TwoFactorAuthillustration from "./TwoFactorAuthillustration";

const TwoFactorAuth: React.FC = () => {
  return (
    <div id="two-factor-auth-page" className="min-h-screen flex flex-col lg:flex-row">
      <div id="two-factor-auth-page-content" className="w-full lg:w-1/2 flex items-center justify-center px-6 sm:px-12 py-12 lg:py-0">
        <TwoFactorAuthVerfication />
      </div>

      <div id="two-factor-auth-page-illustration" className="hidden lg:flex lg:w-1/2 bg-[#E8F0FF] items-center justify-center">
        <TwoFactorAuthillustration />
      </div>
    </div>
  );
};

export default TwoFactorAuth;